import { useState, useContext } from "react";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import {
  cleanObject,
  getRandomIntInclusive,
  getUrlQuerysection,
} from "../../../helpers";
import {
  useCreateChartAccountMutation,
  useUpdateChartAccountMutation,
} from "../../../hooks/api/mutations/useAccounting";
import { useGetAccountTypes } from "../../../hooks/api/queries/useAccountings";
import { useQueryClient } from "react-query";

const useChartAccountLogic = ({
  closeWidget,
  bankInfo,
  handleFetchAccountsList,
}) => {
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const createChartAccountMutation = useCreateChartAccountMutation();
  const updateChartAccountMutation = useUpdateChartAccountMutation();
  const queries = getUrlQuerysection();
  const queryClient = useQueryClient();

  const [bankDetails, setBankDetails] = useState({
    account_name: bankInfo?.account_name || "",
    account_type: bankInfo?.account_type_label || "",
    sub_account_type: bankInfo?.sub_account_type_label || "",
    description: bankInfo?.description || "",
    opening_balance: bankInfo?.opening_balance || "",
    balance_date: bankInfo?.balance_date || "",
  });

  const { data: accountTypes, isLoading: isLoadingAccountTypes } =
    useGetAccountTypes();

  const handleAddChartAccount = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = { ...bankDetails };
    createChartAccountMutation.mutate(cleanObject(data), {
      onSuccess: () => {
        queryClient.invalidateQueries(["getChartOfAccounts", queries]);
        handleFetchAccountsList();
        triggerToast("Chart of account added successfully", "success");
        closeWidget();
      },

      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  // update bank
  const handleEditChartAccount = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = cleanObject(bankDetails);
    updateChartAccountMutation.mutate(
      { id: bankInfo?.id, data },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["getChartOfAccounts", queries]);
          queryClient.invalidateQueries([
            "getChartAccountDetails",
            bankInfo?.id,
          ]);
          handleFetchAccountsList();
          triggerToast("Chart of account updated successfully", "success");
          closeWidget();
        },

        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  return {
    bankDetails,
    setBankDetails,
    handleAddChartAccount,
    handleEditChartAccount,
    updateChartAccountMutation,
    createChartAccountMutation,
    accountTypes: accountTypes || [],
    isLoadingAccountTypes,
  };
};

export default useChartAccountLogic;
